/* Header behavior extracted from sections/header.liquid. */
  document.addEventListener('DOMContentLoaded', function() {
    var headerRoot = document.querySelector('[data-pm-header]');
    var headerSection = headerRoot ? (headerRoot.closest('[id^="shopify-section-"') || headerRoot) : null;
    if (headerSection) {
      document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
    }

    /* ════════════════════════════════════════
       DESKTOP MEGA MENU
    ════════════════════════════════════════ */
    var trigger     = document.querySelector('.pm-nav-bar__link--mega');
    var dropdown    = document.getElementById('pm-mega-dropdown');
    var sidebarItems = document.querySelectorAll('.pm-mega-sidebar__item');
    var megaTriggerLi = document.getElementById('pm-mega-trigger');

    if (trigger && dropdown) {
      function setDropdownTop() {
        var navBar = document.querySelector('.pm-nav-bar');
        if (!navBar) return;
        var rect = navBar.getBoundingClientRect();
        dropdown.style.top = rect.bottom + 'px';
      }
      setDropdownTop();
      closeMega();
      document.documentElement.classList.add('pm-mega-ready');

      function openMega() {
        trigger.setAttribute('aria-expanded', 'true');
        dropdown.setAttribute('aria-hidden', 'false');
        dropdown.classList.add('is-open');
        setDropdownTop();
      }
      function closeMega() {
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.setAttribute('aria-hidden', 'true');
        dropdown.classList.remove('is-open');
      }

      trigger.addEventListener('click', function(e) {
        e.stopPropagation();
        dropdown.classList.contains('is-open') ? closeMega() : openMega();
      });

      document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target) && e.target !== trigger) { closeMega(); }
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') { closeMega(); trigger.focus(); }
      });

      sidebarItems.forEach(function(item) {
        item.addEventListener('mouseenter', function() {
          var panelId = item.getAttribute('data-panel');
          sidebarItems.forEach(function(s) { s.classList.remove('pm-mega-sidebar__item--active'); });
          item.classList.add('pm-mega-sidebar__item--active');
          document.querySelectorAll('.pm-mega-panel').forEach(function(p) {
            p.classList.remove('pm-mega-panel--active');
          });
          var panel = document.getElementById('pm-panel-' + panelId);
          if (panel) { panel.classList.add('pm-mega-panel--active'); }
        });
      });

      if (megaTriggerLi) {
        megaTriggerLi.addEventListener('mouseenter', openMega);
        megaTriggerLi.addEventListener('mouseleave', function() {
          setTimeout(function() {
            if (!dropdown.matches(':hover') && !megaTriggerLi.matches(':hover')) { closeMega(); }
          }, 120);
        });
      }
      dropdown.addEventListener('mouseleave', function() {
        setTimeout(function() {
          if (!dropdown.matches(':hover') && megaTriggerLi && !megaTriggerLi.matches(':hover')) { closeMega(); }
        }, 120);
      });

      window.addEventListener('scroll', setDropdownTop, { passive: true });
      window.addEventListener('resize', setDropdownTop, { passive: true });
    }

    /* ════════════════════════════════════════
       MOBILE MEGA MENU
    ════════════════════════════════════════ */
    var mobileNav = document.getElementById('pm-mobile-nav');
    var headerSearchInput = headerRoot ? headerRoot.querySelector('.search-bar__input') : null;
    var mobileSearchQuery = window.matchMedia('(max-width: 640px)');

    function syncSearchPlaceholder() {
      if (!headerSearchInput) return;
      var mobilePlaceholder = headerSearchInput.getAttribute('data-mobile-placeholder');
      var desktopPlaceholder = headerSearchInput.getAttribute('data-desktop-placeholder');
      headerSearchInput.setAttribute('placeholder', mobileSearchQuery.matches && mobilePlaceholder ? mobilePlaceholder : desktopPlaceholder);
    }

    syncSearchPlaceholder();
    if (mobileSearchQuery.addEventListener) {
      mobileSearchQuery.addEventListener('change', syncSearchPlaceholder);
    } else if (mobileSearchQuery.addListener) {
      mobileSearchQuery.addListener(syncSearchPlaceholder);
    }

    // Hook into the existing Warehouse hamburger button
    // The theme uses [data-action="open-menu"] or [aria-controls="mobile-menu"]
    var hamburgers = document.querySelectorAll(
      '[data-action="open-menu"], [aria-controls="mobile-menu"], .header__mobile-nav-toggle'
    );

    function openMobileNav() {
      if (!mobileNav) return;
      mobileNav.classList.add('is-open');
      mobileNav.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      hamburgers.forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'true');
      });

      var categoriesTrigger = document.querySelector('[data-pm-acc="categories"]');
      var categoriesBody = document.getElementById('pm-acc-categories');
      if (categoriesTrigger && categoriesBody) {
        categoriesBody.classList.add('is-open');
        categoriesTrigger.setAttribute('aria-expanded', 'true');
      }
    }
    function closeMobileNav() {
      if (!mobileNav) return;
      mobileNav.classList.remove('is-open');
      mobileNav.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      hamburgers.forEach(function(btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    }
    closeMobileNav();
    document.documentElement.classList.add('pm-mobile-ready');

    // Attach to hamburger — toggle our mobile nav ON the same click
    hamburgers.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        if (mobileNav) {
          if (mobileNav.classList.contains('is-open')) {
            closeMobileNav();
          } else {
            openMobileNav();
          }
        }
      });
    });

    // Also add a standalone open button if hamburger not found
    if (hamburgers.length === 0 && mobileNav) {
      // Create floating menu button for mobile only
      var floatBtn = document.createElement('button');
      floatBtn.className = 'pm-mobile-open-btn';
      floatBtn.setAttribute('aria-label', 'Open menu');
      floatBtn.innerHTML = '<svg width="22" height="16" viewBox="0 0 22 16" fill="none"><path d="M1 1h20M1 8h20M1 15h20" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
      floatBtn.addEventListener('click', function() {
        mobileNav.classList.contains('is-open') ? closeMobileNav() : openMobileNav();
      });
      document.body.appendChild(floatBtn);
    }

    // Close mobile nav on backdrop click
    if (mobileNav) {
      mobileNav.addEventListener('click', function(e) {
        if (e.target === mobileNav) { closeMobileNav(); }
      });
    }

    // Main accordion — Shop By Categories
    var mainAccTriggers = document.querySelectorAll('[data-pm-acc]');
    mainAccTriggers.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var bodyId = 'pm-acc-' + btn.getAttribute('data-pm-acc');
        var body = document.getElementById(bodyId);
        if (!body) return;
        var isOpen = body.classList.contains('is-open');
        body.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    // Sub-category accordions
    var catTriggers = document.querySelectorAll('[data-pm-cat]');
    catTriggers.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var listId = 'pm-cat-' + btn.getAttribute('data-pm-cat');
        var list = document.getElementById(listId);
        if (!list) return;
        var isOpen = list.classList.contains('is-open');
        list.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    // Sub-category accordions inside each category
    var subcatTriggers = document.querySelectorAll('[data-pm-subcat]');
    subcatTriggers.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var listId = 'pm-subcat-' + btn.getAttribute('data-pm-subcat');
        var list = document.getElementById(listId);
        if (!list) return;
        var isOpen = list.classList.contains('is-open');
        list.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  });
